import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./ConfirmImportToTaxModal.module.css";
import { Col, Modal, Row } from "react-bootstrap";
import { importAllDocumentsToTax } from "../../ClientDocuments/ClientDocuments.service";
import { CustomButton } from "../../../../reusable-components/CustomButtonComponent/button";
import CygnusGrid from "pages/CygnusGrid/CygnusGrid";

/**
 * ConfirmImportToTaxModal Component
 */
const ConfirmImportToTaxModal: React.FC<any> = ({
  show,
  onHide,
  refresh,
  selectedrows,
  returnid,
  clientmasterid,
  importtotaxflag,
  internalk1activities
}) => {
  const [importToTaxConfirmFlag, setImportToTaxConfirmFlag] = useState(false);
  const gridStyle = useMemo(() => ({ height: "300px", minHeight: "100%", width: "100%" }), []);
  const gridRef = useRef(null);

  const confirmModalColdefs: any = [
    {
      headerName: "Type",
      valueGetter: (params: any) => params.data.FormType || params.data.DocumentType || '',
      flex: 1,
    },
    {
      headerName: "Source",
      field: "SourceName",
      flex: 1,
      sortable: false
    },
    {
      headerName: "Identifier",
      field: "SourceTaxId",
      flex: 1,
    },
    {
      headerName: "Source Data",
      field: "FileName",
      flex: 1,
      valueGetter: (params: any) => params.data.DocumentType === 'Internal Schedule K-1' ? params.data.InternalK1SelectedReturnId : params.data.FileName?.placeholder
    },
  ]
  
  useEffect(() => {
    if (internalk1activities && internalk1activities[0]) {
      internalk1activities[0].Mappings.forEach((item: any) => {
        if (item.ChildActivityNumber.includes("_temp")) {
          item.ChildActivityNumber = "";
        }
      });
    }
  }, [])

  const [colDefs, setColDefs] = useState(confirmModalColdefs);

  const confirmImportToTax = async () => {
    setImportToTaxConfirmFlag(true)
    const selectedRowPayload = selectedrows.map((item: any) => ({
      DocumentId: item.DocumentId,
      SourceName: item.SourceName,
      DocumentType: item.DocumentType,
      InternalK1SelectedReturnId: item.DocumentType === "Internal Schedule K-1" ? item.InternalK1SelectedReturnId : ""
    }))

    const payload = {
      "ClientMasterId": clientmasterid,
      "SelectedReturn": returnid?.value,
      "SelectedRows": selectedRowPayload,
      "InternalK1Activities": internalk1activities
    }
    
    console.log(payload)
    const response = await importAllDocumentsToTax(payload);
    setImportToTaxConfirmFlag(false)
    if (response?.success) {
      importtotaxflag();
      refresh();
      onHide();
    }
  }

  const handleClose = () => {
    importtotaxflag();
    onHide();
  }

  return (
    <>
      <div
        className={styles.modaloverlay}
      />
      <Modal
        show={show}
        onHide={() => handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        contentClassName={styles.confirmModal}
        scrollable={false}
      >
        <Modal.Header style={{ paddingBottom: 5 }}>
          <h4 className={styles.header}>&nbsp;Confirmation for Import to Tax</h4>
          <button
            type="button"
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <span style={{ marginLeft: 10, fontSize: 13 }}>
                Return Id - <strong>{returnid?.value}</strong>
              </span>
            </Col>
          </Row>
          <Row className="no-gutter" style={{ marginTop: 10 }}>
            <Col md={12}>
              {
                <div className="externalKone" >
                  <div style={gridStyle}>                    
                    <CygnusGrid
                      key={selectedrows.length}
                      ref={gridRef}
                      columnDefs={colDefs}
                      fetchData={async () => {
                        // Since this is not paginated, just return everything
                        return { records: selectedrows, totalCount: selectedrows.length };
                      }}
                      dataIdentifier="DocumentId"
                      rowSelection="single"                    
                    />
                  </div>
                </div>
              }
            </Col>

          </Row>
          <Row>
            <Col md={12}>
              <div className="d-flex justify-content-end mt-2">                
                <CustomButton
                  progress={importToTaxConfirmFlag}
                  onclick={() => confirmImportToTax()}
                  content={importToTaxConfirmFlag ? "Confirming" : "Confirm"}
                  disable={importToTaxConfirmFlag}
                />
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmImportToTaxModal;
